import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect, useState } from 'react';
import { CRM_SUITE } from 'self-service-api/constants/BundleTypes';
import { FREE } from 'self-service-api/constants/ProductLevels';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import { buildFilteredHighlightedProducts } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { getMobileMerchCardsToShow } from '../../constants/merchCards/MerchCardsToShow';
import MobileProductLevelSelectorButtons from './MobileProductLevelSelectorButtons';
import MobileSuiteFeatureTable from './MobileSuiteFeatureTable';
import MobileSuiteFreeTile from './MobileSuiteFreeTile';
import { MobileSuiteTile } from './MobileSuiteTile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const gridItemProps = {
  paddingInline: '700',
  showBorderLeft: true,
  showBorderRight: true
};
const MobileSuiteTileContainer = ({
  screen
}) => {
  const productLevelsToShow = getMobileMerchCardsToShow(CRM_SUITE);
  const [selectedProductLevel, setSelectedProductLevel] = useState(productLevelsToShow[0]);
  useEffect(() => {
    if (!productLevelsToShow.includes(selectedProductLevel)) {
      setSelectedProductLevel(productLevelsToShow[0]);
    }
  }, [productLevelsToShow, selectedProductLevel]);
  const productsByProductLine = {
    [ProductLines.MARKETING]: buildFilteredHighlightedProducts({
      productLine: ProductLines.MARKETING,
      productLevels: [selectedProductLevel]
    }),
    [ProductLines.SALES]: buildFilteredHighlightedProducts({
      productLine: ProductLines.SALES,
      productLevels: [selectedProductLevel]
    }),
    [ProductLines.SERVICE]: buildFilteredHighlightedProducts({
      productLine: ProductLines.SERVICE,
      productLevels: [selectedProductLevel]
    }),
    [ProductLines.OPERATIONS]: buildFilteredHighlightedProducts({
      productLine: ProductLines.OPERATIONS,
      productLevels: [selectedProductLevel]
    }),
    [ProductLines.CMS]: buildFilteredHighlightedProducts({
      productLine: ProductLines.CMS,
      productLevels: [selectedProductLevel]
    })
  };
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginInline: "auto",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsx(MobileProductLevelSelectorButtons, {
        productLevels: productLevelsToShow,
        selectedProductLevel: selectedProductLevel,
        onClick: setSelectedProductLevel
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "500",
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(CardGrid, {
          columns: 1,
          rowGap: "0",
          children: selectedProductLevel === FREE ? /*#__PURE__*/_jsx(MobileSuiteFreeTile, {
            gridItemProps: gridItemProps
          }) : /*#__PURE__*/_jsx(MobileSuiteTile, {
            productLevel: selectedProductLevel,
            screen: screen,
            gridItemProps: gridItemProps
          })
        })
      }), /*#__PURE__*/_jsx(MobileSuiteFeatureTable, {
        productsByProductLine: productsByProductLine,
        productLevel: selectedProductLevel,
        screen: screen
      })]
    })
  });
};
export default MobileSuiteTileContainer;